<style lang="scss">
    .cart-total{
        margin-top: 10px;
        .total-wrapper {
            color: #ff1466;
        }
        .total{
            font-family: Poppins;
            font-size: 20px;
            font-weight: 600;
        }

        .subtotal{
            font-family: Poppins;
            font-size: 14px;
            font-weight: 500;
        }

        .empty-cart-button{
            color: #ff5b94;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 500;
            float: right;
            margin-top: 5px;
        }

        .continue-shoping-button{
            color: #00d38a;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 500;
            float: left;
        }
        
        .total-wrapper{
            margin-bottom: 0px;
            text-align: right;
        }

        .total-wrapper-empty {
            text-align: center !important;
        }

    }
    .center-text {
        text-align: center !important;

        .continue-shoping-button {
            float: none;
        }
    }
</style>
<template>
    <div class="cart-total" :class="{'center-text': cart.isEmpty()}">
        <h4 class="total-wrapper-empty total-wrapper" v-if="cart.isEmpty()">
            <span class="subtotal" :style="$buyPriceStyle()"> Your Cart is Empty </span>
        </h4>
        <router-link v-if="back" :to="{'path': '/'}" class="continue-shoping-button"><font-awesome-icon :icon="['fal','angle-left']"></font-awesome-icon> Continue Shopping</router-link>
        <h4 class="total-wrapper text-right" v-if="!cart.isEmpty()" :style="$buyPriceStyle()">
		    <span class="subtotal"> Subtotal : </span> <span class="total">{{cart.total | displayPrice }}</span>
        </h4>
	    <a href="javascript:;" @click="cart.empty()" :style="$highlightColor" class="text-right empty-cart-button" v-if="!cart.isEmpty()">Empty Cart</a>
    </div>
</template>

<script>
    import Configure from './../../mixins/configure'

    export default {
        data() {
            return {
            }
        },
        props:{
            'back': {
                type: Boolean,
                default: true
            },
        },
		computed: {
            order(){
                return this.$store.state.order;
            },
            cart(){
                return this.$store.state.cart
            }
        },
        mixins: [Configure]
    }
</script>